module.exports = __webpack_public_path__ + "img/verify.9c52eb5a.png";